import { DatePicker, Form } from 'antd';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import dayjs from 'dayjs';
import React from 'react';

const DatePickerCustomValidate = ({ item, index, form, placeholder, messageRequired, name, initialValue, disabled = false }) => {
  const field = `purpose-${index}`;
  const watchedField = Form.useWatch(field, form);
  const minDate = item?.startDate ? dayjs(item.startDate) : undefined;
  const maxDate = item?.endDate ? dayjs(item.endDate) : undefined;

  const isInvalidRange = minDate && maxDate && minDate.isAfter(maxDate);

  return (
    <Form.Item
      initialValue={initialValue}
      rules={[
        {
          required: !!watchedField,
          message: messageRequired,
        },
      ]}
      name={name}
    >
      <DatePicker
        minDate={isInvalidRange ? undefined : minDate}
        maxDate={isInvalidRange ? undefined : maxDate}
        disabled={disabled}
        className="w-100"
        size="large"
        allowClear={false}
        format={APP_LOCAL_DATE_FORMAT}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};

export default DatePickerCustomValidate;
